<div class="modal-header justify-content-between">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <div>
   <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
  </div>
</div>

<div class="modal-body " *ngIf="configs?.data !== 'null' && configs?.data !== ''; else noDataTemplate">
  <div class="log-content">
    <div style="white-space: pre-wrap">{{ configs?.data }}</div>
  </div>
</div>

<ng-template #noDataTemplate >
  <div class="no-data">
    <app-no-data></app-no-data>
  </div>
</ng-template>
